export type RouteGroup = "site" | "admin" | "legal" | "support";

export interface WebRoute {
  readonly path: string;
  readonly label: string;
  readonly group: RouteGroup;
}

export const WEB_ROUTES = [
  { path: "/", label: "Home", group: "site" },
  { path: "/product", label: "Product", group: "site" },
  { path: "/pricing", label: "Pricing", group: "site" },
  { path: "/download", label: "Download", group: "site" },
  { path: "/how-it-works", label: "How it Works", group: "site" },
  { path: "/privacy-security", label: "Privacy & Security", group: "site" },
  { path: "/whitepaper", label: "Whitepaper", group: "site" },
  { path: "/support", label: "Support", group: "support" },
  { path: "/safety", label: "Safety", group: "support" },
  { path: "/support/safety", label: "Safety", group: "support" },
  { path: "/login", label: "Login", group: "admin" },
  { path: "/admin", label: "Admin", group: "admin" },
  { path: "/terms", label: "Terms", group: "legal" },
  { path: "/privacy", label: "Privacy", group: "legal" },
  { path: "/open-source", label: "Open Source", group: "legal" },
  { path: "/open-source-notices", label: "Open Source Notices", group: "legal" },
  { path: "/contact", label: "Contact", group: "support" }
] as const satisfies readonly WebRoute[];

export type WebRoutePath = (typeof WEB_ROUTES)[number]["path"];
export type AdminSpaceRoutePath = `/admin/spaces/${string}`;
export type NormalizedRoutePath = WebRoutePath | AdminSpaceRoutePath | "/not-found";

export function normalizePath(pathname: string): NormalizedRoutePath {
  const path = pathname.length > 1 && pathname.endsWith("/")
    ? pathname.slice(0, -1)
    : pathname;

  if (isAdminSpacePath(path)) {
    return path;
  }

  return WEB_ROUTES.some((route) => route.path === path)
    ? path as WebRoutePath
    : "/not-found";
}

export function isAdminSpacePath(path: string): path is AdminSpaceRoutePath {
  return /^\/admin\/spaces\/[^/]+$/.test(path);
}

export function getAdminSpaceId(path: AdminSpaceRoutePath): string {
  return decodeURIComponent(path.replace("/admin/spaces/", ""));
}
